import styled from 'styled-components';

export const MyDoctorStyled = styled.div`
  width: 100%;

  .container {
    padding: 0;
  }

  .tab-content {
    width: 100%;

    .tab-pane {
      width: 100%;
    }
  }

  .title {
    margin-left: 0 !important;
  }

  .myDoctorSlider {
    width: 100%;

      a {
        text-decoration: none !important;
        color: ${(props) => props?.theme?.text?.medium};
      }
    }

    .doctorCard {
      text-align: center;
      cursor: pointer;
    }

    .doctorCard__img {
      position: relative;
      margin-bottom: 15px;

      img {
        border-radius: 50%;
      }

      .doctorCard__img__overlay {
        position: absolute;
        top: 58%;
        right: 15%;
        background: white;
        padding: 1px;
        border-radius: 50%;
        box-shadow: 0px 3px 7px 0px rgba(33, 57, 79, 0.08);
        width: 24px;
        height: 24px;

        .bookmark_ic {
          min-width: 16px !important;
          min-height: 16px !important;
        }
      }
    }

    .doctorCard__content {
      h3 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 2px;
        color: ${(props) => props?.theme?.text?.dark};
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: ${(props) => props?.theme?.text?.medium};
      }
    }

    .slick-track {
      margin-left: 0;
      display: flex !important;

      .slick-slide {
        height: auto;
        > div {
          display: flex;
          height: 100%;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .myDoctorSlider {
      .slick-arrow {
        &.slick-next {
          right: 0px;
        }
        &.slick-prev {
          left: 0px;
        }
      }
    }
  }

  @media (max-width: 820px) {
    .slick-slide {
      width: 83vw !important;
    }
  }
`;
